import React from 'react';

const emailError = () => (
  <svg
    width="168"
    height="130"
    viewBox="0 0 168 130"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_ddd)">
      <path
        opacity="0.4"
        d="M131.644 80.5718C132.068 79.4239 83.4522 42.5966 83.4522 42.5966C77.3658 38.0906 74.1647 38.0197 68.146 42.5966C68.146 42.5966 19.6012 79.3942 20.0098 80.5263L20 80.5346C20.005 80.5445 20.0131 80.5512 20.0199 80.5602C20.4315 81.686 21.0303 82.7336 21.791 83.6585C22.1123 84.0494 22.4995 84.3768 22.8719 84.7171L22.8538 84.7311C22.8835 84.7576 22.923 84.7699 22.9526 84.7963C24.5309 86.2088 26.5213 87.1236 28.7324 87.3847C28.7671 87.3889 28.7951 87.407 28.8297 87.4112H28.9632C29.2994 87.4434 29.619 87.5243 29.9632 87.5243H121.743C126.262 87.5243 130.091 84.6731 131.612 80.6762C131.63 80.6464 131.658 80.625 131.674 80.5943L131.644 80.5718Z"
        fill="#4CADBA"
      />
      <path
        opacity="0.6"
        d="M75.8661 38.3702L20.2565 80.2124V20.9361C20.2565 15.1584 24.9242 10.4756 30.6833 10.4756H121.049C126.808 10.4756 131.476 15.1584 131.476 20.9361V80.2124L75.8661 38.3702Z"
        fill="#B0DAE0"
      />
      <path
        d="M20.9051 17.2995L68.3838 54.7123C74.3763 59.1486 77.5281 59.2187 83.4541 54.7123L130.858 17.3588C130.036 15.8631 128.805 14.6815 127.396 13.7394L128.049 13.2268C126.457 11.7734 124.423 10.8313 122.165 10.5879L29.571 10.5912C27.3193 10.8313 25.2818 11.7767 23.6937 13.2268L24.3409 13.733C22.9491 14.6621 21.7293 15.8233 20.9051 17.2995Z"
        fill="#EDECE6"
      />
      <path
        d="M20.8896 17.3768C20.4727 18.5071 68.3393 54.7668 68.3393 54.7668C74.3318 59.2032 77.4836 59.2732 83.4096 54.7668C83.4096 54.7668 131.206 18.5365 130.804 17.4216L130.814 17.4135C130.809 17.4037 130.801 17.3973 130.794 17.3884C130.389 16.2799 129.799 15.2485 129.05 14.3378C128.734 13.9528 128.353 13.6307 127.986 13.2954L128.004 13.2816C127.975 13.2555 127.936 13.2433 127.907 13.2172C126.353 11.8266 124.393 10.9258 122.216 10.6687C122.182 10.6645 122.155 10.6468 122.121 10.6426H121.989C121.658 10.6109 121.343 10.5312 121.004 10.5312H30.639C26.1893 10.5312 22.4192 13.3387 20.9221 17.2739C20.9042 17.3032 20.8767 17.3245 20.8604 17.3544L20.8896 17.3768Z"
        fill="#E0F1F3"
      />
      <rect x="114.014" y="65.3008" width="33.6" height="33.7087" rx="16.8" fill="white" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M144.814 82.1553C144.814 89.8871 138.546 96.1553 130.814 96.1553C123.082 96.1553 116.814 89.8871 116.814 82.1553C116.814 74.4235 123.082 68.1553 130.814 68.1553C138.546 68.1553 144.814 74.4235 144.814 82.1553ZM130.814 93.6098C132.318 93.6098 133.807 93.3135 135.197 92.7379C136.587 92.1622 137.85 91.3185 138.913 90.2549C139.977 89.1912 140.821 87.9285 141.396 86.5387C141.972 85.149 142.268 83.6595 142.268 82.1553C142.268 80.651 141.972 79.1615 141.396 77.7718C140.821 76.3821 139.977 75.1193 138.913 74.0557C137.85 72.992 136.587 72.1483 135.197 71.5727C133.807 70.997 132.318 70.7007 130.814 70.7007C127.776 70.7007 124.862 71.9075 122.714 74.0557C120.566 76.2038 119.359 79.1173 119.359 82.1553C119.359 85.1932 120.566 88.1067 122.714 90.2549C124.862 92.403 127.776 93.6098 130.814 93.6098ZM132.086 74.5189V84.7007H129.541V74.5189H132.086ZM132.086 87.2462V89.7916H129.541V87.2462H132.086Z"
        fill="#B44B3D"
      />
    </g>
    <defs>
      <filter
        id="filter0_ddd"
        x="0"
        y="0.475586"
        width="167.614"
        height="128.534"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="0.5" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="3" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
        <feBlend mode="normal" in2="effect1_dropShadow" result="effect2_dropShadow" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="10" />
        <feGaussianBlur stdDeviation="10" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
        <feBlend mode="normal" in2="effect2_dropShadow" result="effect3_dropShadow" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect3_dropShadow" result="shape" />
      </filter>
    </defs>
  </svg>
);

export default emailError;
